import React from 'react'
import { Button, Input, Label } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class TimeTrackingEstimate extends React.Component {

    render = () => {
        this.props.info('TimeTrackingEstimate.js/render');
        return (
            <tr className='align-items-center mb-4 estimatesDark'>
                <td className="px-1 pb-1 font-weight-bold text-center pt-4">Estimate:</td>
                <td className="px-1 pt-1">
                    <Label>Target Start</Label>
                    <Input
                        type="time"
                        name={"estimatedBeginTime_" + this.props.workflowId + (this.props.taskIndex != null ? "_" + this.props.taskIndex : "")}
                        value={this.props.type.estimates != null ? this.props.isFieldNull(this.props.type.estimates[0].estimatedBeginTime) : ''}
                        disabled={this.props.type.estimates != null ? (((this.props.type.estimates[0].estimatedBeginTime === '' || this.props.type.estimates[0].estimatedBeginTime == null) && (this.props.type.estimates[0].estimatedEndTime === '' || this.props.type.estimates[0].estimatedEndTime == null)) && this.props.type.estimates[0].estimatedDuration > 0) : false}
                        onChange={(e) => this.props.changeWorkflowEstimate(e)}
                    />
                </td>
                <td className="px-1 py-1">
                    <Label>Target End</Label>
                    <Input
                        type="time"
                        name={"estimatedEndTime_" + this.props.workflowId + (this.props.taskIndex != null ? "_" + this.props.taskIndex : "")}
                        value={this.props.type.estimates != null ? this.props.isFieldNull(this.props.type.estimates[0].estimatedEndTime) : ''}
                        disabled={this.props.type.estimates != null ? (((this.props.type.estimates[0].estimatedBeginTime === '' || this.props.type.estimates[0].estimatedBeginTime == null) && (this.props.type.estimates[0].estimatedEndTime === '' || this.props.type.estimates[0].estimatedEndTime == null)) && this.props.type.estimates[0].estimatedDuration > 0) : false}
                        onChange={(e) => this.props.changeWorkflowEstimate(e)}
                        min={this.props.type.estimates != null ? this.props.isFieldNull(this.props.type.estimates[0].estimatedBeginTime) : ''}
                    />
                </td>
                <td className="px-1 py-1">
                    <Label>Target Total Hours</Label>
                    <Input
                        type="number"
                        name={"estimatedDuration_" + this.props.workflowId + (this.props.taskIndex != null ? "_" + this.props.taskIndex : "")}
                        value={this.props.type.estimates != null ? this.props.isFieldNull(this.props.type.estimates[0].estimatedDuration) : ''}
                        disabled={this.props.type.estimates != null ? ((this.props.type.estimates[0].estimatedBeginTime !== '' && this.props.type.estimates[0].estimatedBeginTime != null) || (this.props.type.estimates[0].estimatedEndTime !== '' && this.props.type.estimates[0].estimatedEndTime != null)) : false}
                        onChange={(e) => this.props.changeWorkflowEstimate(e)}
                        min={0}
                        max={24}
                    />
                </td>
                <td className="px-1 pt-4 text-center">
                    {this.props.type.estimates != null && this.props.type.estimates[0].changed && this.props.type.estimates[0].changed != null && <Button
                        color="success"
                        onClick={() => this.props.submitEstimate(this.props.workflowId, this.props.taskIndex)}
                    // disabled={!workflow.estimates[0].changed || workflow.estimates[0].changed == null}
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>}
                </td>
            </tr>


        )
    }
}

export default TimeTrackingEstimate;